import { _Componentes_WebApiCalls_Post } from "../ComponentesGlobales/WebApiCalls";

const numero = (valor) => Number(valor) || 0;

export const listarPuntosVenta = ({ EmpresaId, activo }, opciones) => {
  const request = { EmpresaId };
  if (typeof activo === "boolean") request.activo = activo;
  return _Componentes_WebApiCalls_Post("PuntosVenta/Listar", request, opciones);
};

export const obtenerPuntoVenta = ({ EmpresaId, id }, opciones) =>
  _Componentes_WebApiCalls_Post("PuntosVenta/Get", { EmpresaId, id: numero(id) }, opciones);

export const listarTiposComprobante = ({ EmpresaId }, opciones) =>
  _Componentes_WebApiCalls_Post("Combos/ComprobantesTipos", { EmpresaId }, opciones);

export const crearPuntoVenta = (request, opciones) =>
  _Componentes_WebApiCalls_Post("PuntosVenta/Crear", request, opciones);

export const modificarPuntoVenta = (request, opciones) =>
  _Componentes_WebApiCalls_Post("PuntosVenta/Modificar", request, opciones);

export const eliminarPuntoVenta = ({ EmpresaId, id, operadorId, pcId }, opciones) =>
  _Componentes_WebApiCalls_Post("PuntosVenta/Eliminar", {
    EmpresaId, id: numero(id), operadorId: numero(operadorId), pcId: numero(pcId),
  }, opciones);
